module.exports = __webpack_public_path__ + "static/img/banner-6.ecd73f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-6.png
// module id = 0qnD
// module chunks = 1